module.exports = __webpack_public_path__ + "img/android-icon-192x192.f9dc6237.png";